import { resolveDateRangeWindow } from '@hopdrive/sdk-ui';
import type { DateRangeValue } from '@hopdrive/sdk-ui';

import type { Moves_Bool_Exp } from '@gql/base-types';
import { buildMoveSearchFilter } from '@features/moves/utils/moveSearchFilter';

/** The tab opens on today every visit, with nothing persisted. */
export const TEAM_DEFAULT_RANGE: DateRangeValue = { preset: 'today', startDate: null, endDate: null };

/**
 * `resolveDateRangeWindow` already returns an inclusive window whose `end` is the local end of the
 * last day, so this is a thin adapter. `now` is the seam that keeps it testable.
 */
export function resolveTeamWindow(value: DateRangeValue, now?: Date): { start: string; end: string } {
  const { start, end } = resolveDateRangeWindow(value, now ? { referenceDate: now } : {});
  return { start: start.toISOString(), end: end.toISOString() };
}

/** Search only. The driver sidebar is the driver filter. */
export function buildTeamMapFilters({ search }: { search: string }): Moves_Bool_Exp[] {
  return buildMoveSearchFilter(search);
}
